export default {
    nav: {
        Homepage: "首页",
        ServiceField: "服务领域",
        AboutReeshen: "关于瑞申",
        ContactUs: "联系我们",
        JoinReeshen: "加入瑞申",
        ReeshenHotline: "瑞申热线",
        Consulting: "北京瑞申咨询有限公司",
    },
    mainPage: {
        mainPage1: "瑞申咨询",
        mainPage2: "成为产品合规咨询服务的领先者",
        mainPage3: "查看详情",
        mainPage4: "专业的团队",
        mainPage5: "核心技术团队超过10年以上申报技术服务经验",
        mainPage6: "丰富的沉淀",
        mainPage7: "多年从事产品法规应对及技术咨询服务",
        mainPage8: "优越的资源",
        mainPage9: "和国内外众多优秀实验室建立长期战略合作",
        mainPage10: "良好的渠道",
        mainPage11: "同官方及相关专家建立长期友好的沟通渠道",
        mainPage12: "一站式咨询服务",
        mainPage17: "了解详情>>",
        mainPage26: "数字化产品",
        mainPage27: "农药登记方案系统",
        mainPage28: "一站式农药登记方案平台",
        mainPage29: "为用户提供全面、可靠、透明的数据信息，将强大的顶尖专业技术与丰富业内资源相结合，提供更智能、更高效的一站式合规解决方案。",
        mainPage30: "智能运用资料减免规则并计算撰写资料减免申请，避免不必要的试验，减少沟通时间及成本。",
        mainPage31: "智能学习经验丰富的专业技术团队，运用相同产品、相似产品认定原则，以最智能、高效的计算完成解决方案。",
        mainPage32: "把握最新政策动态，对《农药管理条例》、《农药登记管理办法》及《农药登记资料要求》等深入剖析，提供最优解决方案。",
        mainPage33: "敬请期待",
        mainPage34: "助力企业产品合规少走弯路",
        mainPage35: "产品申报登记注册合规一站式服务专家",
    },
    commonJoinUs: {
        commonJoinUs1: "与我们共事，创想职业新未来。",
        commonJoinUs2: "加入瑞申咨询团队",
        commonJoinUs3: "查看更多",
    },
    cusFooter: {
        cusFooter1: "了解瑞申",
        cusFooter2: "助力企业产品合规少走弯路",
        cusFooter3: "Copyright © 2022  瑞申官网 reeshen.com All Rights Reserved.  备案号：京ICP备2023040342号-1",
        cusFooter4: "联系我们",
        Homepage: "首页",
        ServiceField: "服务领域",
        AboutReeshen: "关于瑞申",
        ContactUs: "联系我们",
        JoinReeshen: "加入瑞申",
    },
    common: {
        Homepage: "首页",
        ServiceField: "服务领域",
        AgriculturalChemicals: "农用化学品",
        IndustrialChemicals: "工业化学品",
        Food: "食品",
        Cosmetics: "化妆品",
        RegistrationOfChinese: "中国农药登记（含新农药）",
        RegistrationOfChinese2: "中国农药登记",
        RiskAssessment: "中国农药风险评估",
        CHINAREACH: "中国新化学物质登记12号令",
        RegistrationAndLicensing: "中国危险化学品登记及许可",
        TechnicalConsulting: "保健食品技术咨询",
        newFoods: "新食品注册申报",
        specialMedical: "特殊医学用途配方食品注册申报",
        cosmetics: "化妆品新原料申报",
        commonSlogn: "致力于帮助各领域企业提供一站式合规解决方案，快速获得市场准入，提升竞争力。",
        RulesBackground: "法规背景",
        ApplicationScope: "适用范围",
        DeclarationSubject: "申报主体",
        RegistrationProcess: "登记流程",
        OurServices: "我们的服务",
        ContactUs: "联系我们",
        MrHe: "何老师",
        MsZhou: "周老师",
        MrLi: "李老师",
        ScopeRegistered: "登记物质范围",
        RegistrationType: "登记类型",
    },
    serviceArea: {
        serviceArea1: "致力于帮助各领域企业提供一站式合规解决方案，快速获得市场准入，提升竞争力。",
    },
    farmChemicalRegister: {
        farmChemicalRegister1: ""
    },
    farmChemicalRiskEstimate: {
        farmChemicalRiskEstimate1: "农药风险评估是基于科学数据及模型，在特定条件下，科学地评价农药在特定环境下对人类健康及环境产生不良效应的可能性和严重性。农药风险评估报告是农药登记资料重要的组成部分，它分为健康风险评估报告、环境风险评估报告和膳食风险评估报告3类。2017年生效的《农药登记资料要求》对不同产品登记类型所需要的风险评估报告做出了明确的规定。",
        farmChemicalRiskEstimate2: "健康风险评估",
        farmChemicalRiskEstimate3: "根据目标人群的不同，健康风险评估目前主要分为职业健康风险评估、居民健康风险评估。职业健康风险评估主要是综合评价施药人员在农药混配、施药等操作过程中的健康风险；居民健康风险评估主要是评价气雾剂、驱避剂等产品在使用过程中对居民健康带来的风险。",
        farmChemicalRiskEstimate4: "主要评估依据包括：",
        farmChemicalRiskEstimate5: "NY/T 3153-2017《农药施用人员健康风险评估指南》",
        farmChemicalRiskEstimate6: "《背负式喷雾施药人员单位暴露量（第一版）》",
        farmChemicalRiskEstimate7: "《农药施用人员健康风险评估指南》（可选）；",
        farmChemicalRiskEstimate8: "《卫生杀虫剂健康风险评估指南 第1部分：蚊香类产品》（可选）；",
        farmChemicalRiskEstimate9: "《卫生杀虫剂健康风险评估指南 第2部分：气雾剂》（可选）；",
        farmChemicalRiskEstimate10: "《卫生杀虫剂健康风险评估指南 第3部分：驱避剂》（可选）。",
        farmChemicalRiskEstimate11: "环境风险评估",
        farmChemicalRiskEstimate12: "农药环境风险评估是指系统地采用科学技术及信息，在特定条件下，就农药使用对生态环境产生不良效应的潜在风险和程度进行科学评估。目前需要开展农药登记环境风险评估的项目包括水生生态系统、鸟类、蜜蜂、家蚕、地下水、非靶标节肢动物和土壤生物。",
        farmChemicalRiskEstimate13: "主要评估依据包括：",
        farmChemicalRiskEstimate14: "NYT 2882.1-2016农药登记 环境风险评估指南 第1部分：总则",
        farmChemicalRiskEstimate15: "NYT 2882.2-2016农药登记 环境风险评估指南 第2部分：水生生态系统",
        farmChemicalRiskEstimate16: "NYT 2882.3-2016农药登记 环境风险评估指南 第3部分：鸟类",
        farmChemicalRiskEstimate17: "NYT 2882.4-2016农药登记 环境风险评估指南 第4部分：蜜蜂",
        farmChemicalRiskEstimate18: "NYT 2882.5-2016农药登记 环境风险评估指南 第5部分：家蚕",
        farmChemicalRiskEstimate19: "NYT 2882.6-2016农药登记 环境风险评估指南 第6部分：地下水",
        farmChemicalRiskEstimate20: "NYT 2882.7-2016农药登记 环境风险评估指南 第7部分：非靶标节肢动物",
        farmChemicalRiskEstimate21: "NYT 2882.8-2017农药登记 环境风险评估指南 第8部分：土壤生物",
        farmChemicalRiskEstimate22: "膳食风险评估",
        farmChemicalRiskEstimate23: "膳食风险评估是指通过分析农药毒理学和残留化学试验结果，根据消费者膳食结构，对因膳食摄入农药残留产生健康风险的可能性及程度进行科学评估。它又包括毒理学评估、残留化学评估、膳食摄入评估和风险标准。",
        farmChemicalRiskEstimate24: "主要评估依据包括：",
        farmChemicalRiskEstimate25: "《农药残留风险评估指南》",
        farmChemicalRiskEstimate26: "《农药每日允许摄入量制定指南》",
        farmChemicalRiskEstimate27: "《农药急性参考剂量制定指南》",
        farmChemicalRiskEstimate28: "《农作物中农药代谢试验准则(NY/T 3096-2017)》",
        farmChemicalRiskEstimate29: "《加工农产品中农药残留试验准则(NY/T 3095-2017)》",
        farmChemicalRiskEstimate30: "《植物源性农产品中农药残留稳定性试验准则(NY/T 3094-2017）》",
        farmChemicalRiskEstimate31: "《农药残留试验准则（NY/T 788）》的规定进行。",
        farmChemicalRiskEstimate32: "我们的服务",
        farmChemicalRiskEstimate33: "健康风险评估报告",
        farmChemicalRiskEstimate34: "环境风险评估报告",
        farmChemicalRiskEstimate35: "膳食风险评估",
    },
    industryChemical12: {
        industryChemical1:"2020年4月29日，生态环境部发布了最新修订的《新化学物质环境管理登记办法》（生态环境部12号令，以下称《登记办法》或“12号令”），并自2021年1月1日施行。2010年1月19日原环境保护部发布的《新化学物质环境管理办法》（环境保护部令第7号）同时废止。《登记办法》规定：“新化学物质的生产者或者进口者，应当在生产前或者进口前取得新化学物质环境管理常规登记证或者简易登记证或者办理新化学物质环境管理备案。”",
        industryChemical2:"在《新化学物质环境管理登记办法》下，凡未列入IECSC《中国现有化学物质名录》的化学物质为新化学物质。申请人需对未列入IECSC的新化学物质需履行登记义务，对于配制品中含有的新化学物质和物品中有意释放的新化学物质也在登记之列。生产医药、农药、兽药、化妆品、食品添加剂、饲料、饲料添加剂、肥料等产品的原料或中间体，属于新化学物质的，也需要进行登记。已列入《名录》但规定实施新用途环境管理的化学物质，用于允许用途以外的其他工业用途的，需办理新用途登记。",
        industryChemical3:"备案",
        industryChemical4:"简易登记",
        industryChemical5:"常规登记",
        industryChemical6:"新化学物质年生产量或进口量不足1吨的；",
        industryChemical7:"新化学物质单体或反应体含量不超过2％的聚合物；或属于低关注聚合物，且不符合聚合物备案排除情形的。",
        industryChemical8:"新化学物质年生产量或进口量1吨以上不足10吨的；",
        industryChemical9:"新化学物质年生产量或进口量在10吨以上的。",
        industryChemical10:"中国新化学物质法规咨询和培训服务",
        industryChemical11:"中国新污染物的治理法规咨询和培训服务",
        industryChemical12:"中国新化学物质法规应对优质方案设计",
        industryChemical13:"中国新化学物质查新",
        industryChemical14:"中国新化学物质登记（备案、简易登记、常规登记）",
        industryChemical15:"非测试方法数据评估服务（QSAR、READ-ACROSS、WOE）",
        industryChemical16:"新化学物质风险评估报告编写",
        industryChemical17:"中国现有化学物质名录增补申报",
        industryChemical18:"申报代理及登记证管理",
        industryChemical19:"社会经济效益分析报告",
        industryChemical21:"致癌性评估",
    },
    industryChemicalRiskRegister: {
        industryChemicalRiskRegister1: "《危险化学品登记管理办法》（国家安监总局第53号）规定，生产或进口危险化学品的企业需要进行危险化学品登记，违反规定的企业将收到相应处罚，情节严重的，责令停产停业整顿。对于易制毒化学品、剧毒化学品、易制爆化学品、监控化学品、严格限制的有毒化学品等特殊种类的危险化学品，企业只有在取得相应资质后，才能合法合规地进行危险化学品的生产经营等活动。",
        industryChemicalRiskRegister2: "危险化学品安全生产/经营/使用许可",
        industryChemicalRiskRegister3: `适用范围：`,
        industryChemicalRiskRegister4: `危险化学品：列入《危险化学品目录》（2015）的化学品以及主要成分均列入《目录》且主要成分质量比或体积比之和不小于70%的混合物（经鉴定不属于危险化学品确定原则的除外）；`,
        industryChemicalRiskRegister5: `在中华人民共和国境内从事危险化学品的生产、经营（包括仓储经营）活动的企业；`,
        industryChemicalRiskRegister6: `列入危险化学品安全使用许可适用行业目录、使用危险化学品从事生产并且达到危险化学品使用量的数量标准的化工企业（危险化学品生产企业除外）。`,
        industryChemicalRiskRegister7: `易制毒化学品管理`,
        industryChemicalRiskRegister8: `易制毒化学品：列入《易制毒化学品的分类和品种目录》中的物质，以及《目录》第一类、第二类所列物质可能存在的盐类，第一类中的药品类易制毒化学品包括原料及其单方制剂；`,
        industryChemicalRiskRegister9: `易制毒化学品的生产、经营、购买、运输和进出口等。`,
        industryChemicalRiskRegister10: `监控化学品`,
        industryChemicalRiskRegister11: `监控化学品：列入《各类监控化学品名录》和《列入第三类监控化学品的新增品种清单》中的化学品；`,
        industryChemicalRiskRegister12: `从事监控化学品的生产、储存、经营、使用、购买销售、进出口的企业。`,
        industryChemicalRiskRegister13: `剧毒化学品/易制爆化学品管理`,
        industryChemicalRiskRegister14: `剧毒化学品：《危险化学品目录》（2015）中备注为剧毒的化学品；`,
        industryChemicalRiskRegister15: `易制爆危险化学品：列入《易制爆危险化学品名录（2017）》的化学品；`,
        industryChemicalRiskRegister16: `从事剧毒化学品以及易制爆危险化学品的生产、储存、经营、购买、运输的企业。`,
        industryChemicalRiskRegister17: `严格限制的有毒化学品进出口环境管理登记`,
        industryChemicalRiskRegister18: `进出口列入《中国严格限制的有毒化学品名录》中化学品的企业，以及相关生产、使用和经营企业。`,
        industryChemicalRiskRegister19: `危险化学品安全生产/经营/使用许可办理`,
        industryChemicalRiskRegister20: `易制毒/监控化学品管理咨询`,
        industryChemicalRiskRegister21: `剧毒化学品/易制爆化学品管理咨询`,
        industryChemicalRiskRegister22: `严格限制的有毒化学品进出口环境管理登记办理`,
    },
    healthFoods: {
        healthFoods1: `根据国家市场监督管理总局发布的最新版本的《保健食品注册与备案管理办法》，保健食品在中国市场上市销售前，企业需要申请并获得保健食品注册证书或备案凭证。使用保健食品原料目录以外原料的国产保健食品和首次进口的保健食品（属于补充维生素、矿物质等营养物质的保健食品除外）都需要向国家市场监管总局（SAMR）申请注册。`,
        healthFoods2: `保健食品注册申请人资质要求`,
        healthFoods3: `国产保健食品注册申请人应当是在中国境内登记的法人或者其他组织。`,
        healthFoods4: `进口保健食品注册申请人应当是上市保健食品的境外生产厂商（境外生产厂商，是指产品符合所在国（地区）上市要求的法人或者其他组织）。`,
        healthFoods5: `注册流程`,
        healthFoods6: `国产/进口保健食品备案`,
        healthFoods7: `国产/进口保健食品注册`,
        healthFoods8: `保健食品配方和工艺研发`,
        healthFoods9: `保健食品新功能申报`,
        healthFoods10: `保健食品老批件“清理换证”变更注册`,
        healthFoods11: `国产/进口保健食品转让技术注册`,
        healthFoods12: `国产/进口保健食品变更注册`,
        healthFoods13: `国产/进口保健食品延续注册`,
        healthFoods14: `保健食品法规培训`,
        healthFoods15: `组织专家论证和评估等`,
    },
    newFoodsRegister: {
        newFoodsRegister1: `《中华人民共和国食品安全法》第三十七条规定：利用新的食品原料生产食品，或者生产食品添加剂新品种、食品相关产品新品种，应当向国务院卫生行政部门提交相关产品的安全性评估材料。第九十三条规定：进口利用新的食品原料生产的食品或者进口食品添加剂新品种、食品相关产品新品种，依照本法第三十七条的规定办理。`,
        newFoodsRegister2: `新食品原料`,
        newFoodsRegister3: `新食品原料是指在我国无传统食用习惯的以下物品：`,
        newFoodsRegister4: `动物、植物和微生物；`,
        newFoodsRegister5: `从动物、植物和微生物中分离的成分；`,
        newFoodsRegister6: `原有结构发生改变的食品成分；`,
        newFoodsRegister7: `其他新研制的食品原料。`,
        newFoodsRegister8: `同时，新食品原料应当具有食品原料的特性，符合应当有的营养要求，且无毒、无害，对人体健康不造成任何急性、亚急性、慢性或者其他潜在性危害。`,
        newFoodsRegister9: `食品添加剂新品种`,
        newFoodsRegister10: `食品添加剂新品种是指：`,
        newFoodsRegister11: `未列入食品安全国家标准 (GB2760 和 GB14880) 的食品添加剂新品种；`,
        newFoodsRegister12: `未列入卫健委公告允许使用的食品添加剂新品种；`,
        newFoodsRegister13: `扩大使用范围或者用量的食品添加剂。`,
        newFoodsRegister14: `拟从事新食品原料生产、使用或者进口的单位或者个人。`,
        newFoodsRegister15: `新食品原料申报`,
        newFoodsRegister16: `新食品添加剂申报`,
        newFoodsRegister17: `食品新品种申报`,
        newFoodsRegister18: `法规咨询`,
        newFoodsRegister19: `申报可行性评估`,
        newFoodsRegister20: `资料审核及申报建议`,
        newFoodsRegister21: `安排试验并评估检测报告的可用性`,
        newFoodsRegister22: `撰写标准化申报资料`,
        newFoodsRegister23: `跟进评审进度`,
    },
    medicalFoods: {
        medicalFoods1: `《中华人民共和国食品安全法》第三十七条规定：利用新的食品原料生产食品，或者生产食品添加剂新品种、食品相关产品新品种，应当向国务院卫生行政部门提交相关产品的安全性评估材料。第九十三条规定：进口利用新的食品原料生产的食品或者进口食品添加剂新品种、食品相关产品新品种，依照本法第三十七条的规定办理。`,
        medicalFoods2: `特殊医学用途配方食品`,
        medicalFoods3: `特殊医学用途配方食品，是指为满足进食受限、消化吸收障碍、代谢紊乱或者特定疾病状态人群对营养素或者膳食的特殊需要，专门加工配制而成的配方食品，包括适用于0月龄至12月龄的特殊医学用途婴儿配方食品和适用于1岁以上人群的特殊医学用途配方食品。`,
        medicalFoods4: `注册申报流程`,
        medicalFoods5: `注册预评估`,
        medicalFoods6: `注册卷宗制作`,
        medicalFoods7: `注册测试监理`,
        medicalFoods8: `专家、评审部门沟通`,
        medicalFoods9: `法规培训服务`,
    },
    makeupNewMaterial: {
        makeupNewMaterial1: `2020年6月29日，国务院发布《化妆品监督管理条例》（国令第727号），规定化妆品新原料需向国务院药品监督管理部门申请注册或者备案后才能用于化妆品中。`,
        makeupNewMaterial2: `定义及判定原则`,
        makeupNewMaterial3: `定义`,
        makeupNewMaterial4: `我国境内首次使用于化妆品的天然或者人工原料为化妆品新原料。`,
        makeupNewMaterial5: `判定原则`,
        makeupNewMaterial6: `国家药品监督管理局于2021年4月27日发布的《已使用化妆品原料目录（IECIC）（2021年版）》（2021年第62号），代替IECIC 2015版，作为化妆品原料的判断依据。不在此目录内的原料，即被认为化妆品新原料，需通过注册/备案后，方可加入化妆品中。`,
        makeupNewMaterial7: `调整已使用的化妆品原料的使用目的、安全使用量等的，应当按照新原料注册、备案要求申请注册进行备案。`,
        makeupNewMaterial8: `管理方式`,
        makeupNewMaterial9: `具有防腐、防晒、着色、染发、祛斑美白功能的化妆品新原料，经国务院药品监督管理部门注册后方可使用。`,
        makeupNewMaterial10: `其他化妆品新原料应当在使用前向国务院药品监督管理部门备案。`,
        makeupNewMaterial11: `申报流程`,
        makeupNewMaterial12: `中国化妆品新原料注册备案`,
        makeupNewMaterial13: `毒理数据缺口分析及申报方案制定`,
        makeupNewMaterial14: `化妆品新原料申报实验监理`,
        makeupNewMaterial15: `化妆品原料安全评估报告`,
        makeupNewMaterial16: `化妆品新原料技术补正`,
        makeupNewMaterial17: `化妆品原料报送码申请`,
        makeupNewMaterial18: `国内外的使用历史资料查找`,
    },
    aboutRs: {
        aboutRs1: `专注于产品合规咨询及技术服务，致力于帮助企业制定更专业、更高效的一站式合规解决方案。从始至终，一以贯之。`,
        aboutRs2: `北京瑞申咨询`,
        aboutRs3: `专注产品合规咨询及技术服务`,
        aboutRs4: `北京瑞申咨询有限公司专注于产品合规咨询及技术服务，服务领域覆盖工业化学品、农药、食品&保健食品、化妆品、消杀产品等多个行业。我们一直致力于帮助企业实现产品合规，快速获得市场准入，提升竞争力。我们将强大的咨询能力、顶尖的专业技术与丰富的业内资源相结合，为企业提供更专业、更高效的一站式合规解决方案，从始至终，一以贯之。`,
        aboutRs5: `自公司成立以来，瑞申汇集了一支不同领域、专业技术能力强的专家团队。团队一直秉持着最基本的精神和价值观，助力行业和市场环境可持续发展。作为法规合规服务商，瑞申同各行业协会及组织机构保持着紧密的合作关系。我们深知客户的诉求，同时也熟知实验室体系的运行与需求，对各行业法规变化有敏锐嗅觉与积极的应对方案。`,
        aboutRs6: `瑞申制定的一站式解决方案，让企业产品合规少走弯路，助力企业将愿景变为现实。`,
        aboutRs7: `专业的团队`,
        aboutRs8: `丰富的沉淀`,
        aboutRs9: `优越的资源`,
        aboutRs10: `良好的渠道`,
        aboutRs11: `瑞申企业文化`,
        aboutRs12: `我们的使命`,
        aboutRs13: `我们的愿景`,
        aboutRs14: `我们的核心价值观`,
    },
    ContactUs: {
        ContactUs1: `联系我们`,
        ContactUs2: `非常感谢您垂询北京瑞申咨询有限公司，瑞申为企业提供更专业、更高效的一站式合规解决方案。`,
        ContactUs3: `瑞申热线`,
        ContactUs4: `瑞申邮箱`,
        ContactUs5: `瑞申官网`,
    },
    joinRs: {
        joinRs1: "加入我们",
        joinRs2: "瑞申为人才提供发展平台和工作机遇，让人才得以充分发挥潜力。为员工建立灵活、敏捷的积极工作环境。不凡成就，职在德勤。",
        joinRs3: "带薪休假",
        joinRs4: "健康体检",
        joinRs5: "节日福利",
        joinRs6: "生日福利",
        joinRs7: "团队建设",
        joinRs8: "招聘岗位",
        joinRs9: "专业要求",
        joinRs10: "薪资待遇",
        joinRs11: "查看详情",
        joinRs12: "保健食品注册经理",
        joinRs13: "食品、药品、生物、营养等相关专业",
        joinRs14: "薪资面议",
        joinRs15: "农药客户经理",
        joinRs16: "专业不限",
        joinRs17: "薪资面议",
        joinRs18: "新化学物质客户经理",
        joinRs19: "专业不限",
        joinRs20: "薪资面议",
        joinRs21: "岗位职责：",
        joinRs22: "1. 根据中国法规要求，制定公司保健食品研究承接项目的可行性分析报告；",
        joinRs23: "2. 熟悉国产、进口保健食品注册备案相关法规及申报要求；",
        joinRs24: "3. 负责产品配方、安全性、功能性论证，组织保健食品小试、生产，与检测机构、医院、主管单位等做好沟通协调；",
        joinRs25: "4. 申报材料整理、撰写，跟进申报进度，解决申报过程中的问题。",
        joinRs26: "任职要求：",
        joinRs27: "1. 食品、药品、生物、营养等相关专业；",
        joinRs28: "2. 8年以上保健食品注册经验；",
        joinRs29: "3. 较强的沟通协调能力和团队精神，责任心强。",
        joinRs30: "简历投递：",
        joinRs31: `1. 负责农药登记业务开发；`,
        joinRs32: `2. 梳理行业区域客户，对客户有效拜访；`,
        joinRs33: `3. 负责新客户开发及老客户维护；`,
        joinRs34: `4. 维护客户各层级各部门良好的合作关系；`,
        joinRs35: `1. 销售工作3年以上；`,
        joinRs36: `2. 有成功的销售履历，有农药登记或检测背景尤佳；`,
        joinRs37: `3. 自我驱动力强，有责任心；`,
        joinRs38: `4. 较强的学习能力；`,
        joinRs39: `5. 适应出差。`,
        joinRs40: `候选人如有行业资源，可home base`,
        joinRs41: `1. 负责新化学物质登记业务开发；`,
        joinRs42: `2. 梳理行业区域客户，对客户有效拜访；`,
        joinRs43: `3. 组织技术团队制作项目方案；`,
        joinRs44: `4. 维护客户各层级各部门良好的合作关系。`,
        joinRs45: `1. 销售工作3年以上；`,
        joinRs46: `2. 有成功的销售履历；`,
        joinRs47: `3. 自我驱动力强，有责任心；`,
        joinRs48: `4. 较强的学习能力；`,
        joinRs49: `5. 适应出差。`,
    }
}
